/** @format */

import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  hideDeleteModal,
  hideExpense,
  toggleRender,
} from "../../../store/stateSlice";
import Popup from "../../global/form create/Popup";
import InputField from "../../inputs/inputField";
import InputTextarea from "../../inputs/inputTextarea";
import price from "../../../Assets/images/price.png";
import InputCalender from "../../inputs/inputCalender";
import HeadTitle from "../../global/HeadTitle";
import { delOne } from "../../../store/helper";
import { Spinner1 } from "../../spinners/Spinner1";
import { setCategoryID } from "../../../store/category";
import { deleteClient } from "../../../services/clintServices";
import { deleteClientRTK } from "../../../store/clients";
import { deleteCategoryRTK } from "../../../store/category";
import { deleteServiceRTK } from "../../../store/service";

const DeleteModal = (props) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const modal = useSelector((state) => state.toggleState.value);
  const category = useSelector((state) => state.category);
  const service = useSelector((state) => state.service);
  const client = useSelector((state) => state.clientSlice);

  const hidePopup = () => {
    dispatch(hideDeleteModal());
  };
  const handleDeleteCat = () => {
    switch (props.from) {
      case "category":
        dispatch(delOne({ id: category.id, path: "/categories/" })).then(
          (res) => {
            dispatch(hideDeleteModal());
            dispatch(deleteCategoryRTK());
          }
        );
        setLoading(category.loading);

        break;
      case "service":
        dispatch(
          delOne({
            id: props.id,
            path: "/services/",
          })
        ).then((res) => {
          dispatch(hideDeleteModal());
          props.getAllServices();
          dispatch(deleteServiceRTK());
        });
        setLoading(service.loading);
        break;
      case "client":
        dispatch(deleteClient("/clients/" + client.id)).then((res) => {
          dispatch(hideDeleteModal());
          dispatch(deleteClientRTK());
          // dispatch(toggleRender());
        });
        setLoading(client.loading);
        break;
      default:
        return;
    }
  };
  return (
    <Popup
      viewPupup={modal.deleteModel}
      hidePupup={hidePopup}
      viewWidth='content-small'>
      {loading && <Spinner1 />}
      <form className='main-contnt'>
        <div className='head-content'>
          <HeadTitle title='هل انت متاكد من هذا الحذف ؟' />
        </div>
        <div className='body-content'></div>
        <div className='buttons-contnt display-flex center-flex '>
          <div class='btn btn__primary' onClick={handleDeleteCat}>
            تأكيد
          </div>
          <div class='btn btn__danger' onClick={hidePopup}>
            الغاء
          </div>
        </div>
      </form>
    </Popup>
  );
};

export default DeleteModal;
